import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[onlyNumber]' // Avoid disabling lint rules; follow best practices
})
export class OnlyNumber {
  private readonly regex: RegExp = /^[0-9]*$/;

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) 
  onInputChange(event: Event): void {
    const initialValue: string = this.el.nativeElement.value;
    this.el.nativeElement.value = initialValue.replace(/\D/g, ''); // Remove non-digit characters
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }

  // @HostListener('paste', ['$event'])
  // blockPaste(event: ClipboardEvent): void {
  //   event.preventDefault();
  //   const pastedValue = event.clipboardData?.getData('text') || '';
  //   const numericValue = pastedValue.replace(/\D/g, '');
  //   this.el.nativeElement.value = numericValue;
  //   if (numericValue !== this.el.nativeElement.value) {
  //     event.stopPropagation();
  //   }
  // }
}
